module.exports = __webpack_public_path__ + "__assets__/img/slogan_t@2x.0ab97cbb.png";